import $ from 'jquery';

const SELECTOR = '.service-explorer';
const ITEM_SELECTOR = '.service-explorer-item';

function onDocumentReady() {
	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	$(el).on('click', ITEM_SELECTOR, onClickServiceExplorerItem);
}

function onClickServiceExplorerItem(e) {
	const clicked = $(e.currentTarget);

	if (clicked.hasClass('active')) {
		deactivateItem(clicked);
	} else {
		deactivateItem(clicked.closest(SELECTOR).find(`${ITEM_SELECTOR}.active`));
		activateItem(clicked);
	}
}

function activateItem($item) {
	$item.addClass('active').find('.more-info').stop(true, false).slideDown();
}

function deactivateItem($item) {
	$item.removeClass('active').find('.more-info').stop(true, false).slideUp();
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
